import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=54ef68ed&scoped=true"
import script from "./file-uploader.ts?vue&type=script&lang=ts&external"
export * from "./file-uploader.ts?vue&type=script&lang=ts&external"
import style0 from "./file-uploader.less?vue&type=style&index=0&id=54ef68ed&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef68ed",
  null
  
)

export default component.exports